import React, { useState, useEffect, useRef } from 'react'
import styles from './styles.module.scss'
import { formatDate } from 'srcReact/helpers/datetimeHelper'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getDateFormat4 } from '../../../helpers/datetimeHelper'

const CarouselDateCard = ({ date, mixrId, selected, isStatic }) => {
  const [formattedDate, setFormattedDate] = useState('')
  const { t } = useTranslation()
  useEffect(() => {
    let dtDate = new Date(date)
    setFormattedDate(formatDate(dtDate, getDateFormat4()))
  }, [date])

  return isStatic ? (
    <div className={`${styles.carouselCard} ${styles.inactive}`}>{formattedDate}</div>
  ) : (
    <Link className={`${styles.carouselCard}  ${selected && styles.selectedCard}`} to={`/0/home/event/${mixrId}`}>
      {formattedDate}
    </Link>
  )
}

export default CarouselDateCard
